export default __webpack_public_path__ + "static/media/duckduckgo.7263035b.svg";